import axios from 'axios';
import { systemOf } from '../constants/systems';

/**
 * PATCH /{switches|blowers}/update-device/{deviceId}: freeze or unfreeze a
 * device. Blower systems carry their deviceType; the user is recorded in the
 * system's freeze-by field (TES: e_freeze_by).
 * @param {'ess'|'tgs'|'tes'} system  a DEVICE_TYPES value works too
 * @param {0|1|boolean} freezeValue
 * @param {string} deviceId
 * @param {string} userId
 * @returns {Promise<*>}
 */

export const freezeDevice = async (system, freezeValue, deviceId, userId) => {
  const { resource, deviceType, freezeByField } = systemOf(system);
  const response = await axios.patch(`/${resource}/update-device/${deviceId}`, {
    freeze: freezeValue,
    ...(resource === 'blowers' && { deviceType }),
    [freezeByField]: userId,
  });
  return response.data;
};
